import React, { useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { eyeOff } from "react-icons-kit/feather/eyeOff";
import { eye } from "react-icons-kit/feather/eye";

const LoginFields = () => {
  const [icon, setIcon] = useState(eyeOff);
  const [type, setType] = useState("password");

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

  const handleLoginPasswordToggle = () => {
    if (type === "password") {
      setIcon(eye);
      setType("text");
    } else {
      setIcon(eyeOff);
      setType("password");
    }
  };

  const handleLogin = async (e) => {
    if (!email.trim() && !password.trim()) {
      toast.error("Both fields are required!");
      return;
    }
    if (!email.trim()) {
      toast.error("Enter your Email ID");
      return;
    }
    if (!emailRegex.test(email.trim())) {
      toast.error("Please enter a valid email!");
      return;
    }

    if (!password.trim()) {
      toast.error("Enter Your Password");
      return;
    }

    setError("");
    try {
      const data = { email, password };

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/superadmin/login/`,
        data
      );

      toast.success("Login successful!");
      localStorage.setItem("loggedIn", "true");
      setTimeout(() => {
        window.location.href = "/dashboard";
      }, 1000);

      console.log("response.data", response.data);
    } catch (error) {
      console.log("message", error);
      if (error.response) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Unable to reach the server");
      }
    }
  };

  return (
    <div className="bg-white text-gray-900 rounded-lg p-8 shadow-lg w-[350px] mx-auto border border-[#B0B0B0]">
      <h4 className="text-xl font-semibold text-center mb-6">Login</h4>

      {error && (
        <div className="text-red-600 text-sm text-center mb-4">{error}</div>
      )}

      <div className="space-y-4">
        <div className="w-full space-y-5">
          {/* Email Field */}
          <div className="relative">
            <input
              type="text"
              name="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="block w-full px-2.5 pb-2.5 pt-4 text-[14px] bg-transparent border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#181818] peer h-[40px]"
              placeholder="Email"
            />
          </div>

          {/* Password Field */}
          <div className="relative">
            <input
              type={type}
              name="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="block w-full px-2.5 pb-2.5 pt-4 text-[14px] bg-transparent border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#181818] peer h-[40px]"
              placeholder="Password"
            />
          </div>
        </div>
        
        <button
          className="w-full bg-[#181818] text-white py-3 rounded-md hover:bg-[#282828] transition duration-300 top text-sm"
          onClick={handleLogin}
        >
          LOGIN
        </button>
      </div>
    </div>
  );
};

export default LoginFields;